// client/src/components/Layout/MobileNav.jsx
import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Avatar,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * Мобильная навигация – выдвижное меню (Drawer)
 * @param {boolean} open - состояние открытия
 * @param {Function} onClose - закрыть меню
 * @param {Array} menuItems - массив пунктов меню: { text, icon, path, roles }
 */
const MobileNav = ({ open, onClose, menuItems }) => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
    onClose();
  };

  // Фильтруем пункты меню по роли пользователя
  const filteredItems = menuItems.filter((item) =>
    item.roles?.includes(user?.role) ?? true
  );

  return (
    <Drawer anchor="left" open={open} onClose={onClose} sx={{ '& .MuiDrawer-paper': { width: 280 } }}>
      {/* Кнопка закрытия */}
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Профиль пользователя */}
      <Box sx={{ textAlign: 'center', py: 2, px: 3 }}>
        <Avatar
          sx={{
            width: 80,
            height: 80,
            mx: 'auto',
            mb: 1,
            bgcolor: 'primary.main',
            fontSize: 32,
          }}
        >
          {user?.fullName?.charAt(0) || 'U'}
        </Avatar>
        <Typography variant="subtitle1" fontWeight={600}>
          {user?.fullName}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {user?.role?.toUpperCase()}
        </Typography>
      </Box>

      <Divider />

      {/* Пункты меню */}
      <List sx={{ flexGrow: 1, px: 1 }}>
        {filteredItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton onClick={() => handleNavigation(item.path)} sx={{ borderRadius: 2, mb: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} primaryTypographyProps={{ fontSize: 14 }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Divider />

      {/* Кнопка выхода */}
      <List sx={{ px: 1, pb: 2 }}>
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout} sx={{ borderRadius: 2, color: 'error.main' }}>
            <ListItemIcon sx={{ minWidth: 40, color: 'error.main' }}>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </ListItem>
      </List>
    </Drawer>
  );
};

export default MobileNav;